<template>
  <!-- Login Module -->
  <v-content>
    <v-card width="400" class="mx-auto mt-5">
      <v-card-title>
        <h1 class="display-1">Login</h1>
      </v-card-title>
      <v-card-text>
        <p>{{ this.$store.state.loginError }}</p>
        <v-form>
          <v-text-field
            label="Username"
            v-model="username"
            prepend-icon="mdi-account-circle"
          />
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            label="Password"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            v-model="password"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn @click="login" color="info" block>Login</v-btn>
      </v-card-actions>
    </v-card>
  </v-content>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      showPassword: false,
      username: "",
      password: ""
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch("login", {
          username: this.username,
          password: this.password,
          appid: 1
        })
        .then(() => {
          if (this.$store.state.loginSuccess == false) {
            console.log(this.$store.state.loginError);
          } else {
            this.$store.commit("SHOW_SEARCHBAR", true);
            this.$router.push({ name: "Expected" });
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    }
  }
};
</script>

<style></style>
